/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This tool only decodes the token — it does NOT verify the signature. Never trust a decoded token as proof of authentication.`)
};

const es_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta herramienta solo decodifica el token, NO verifica la firma. Nunca confíes en un token decodificado como prueba de autenticación.`)
};

const de_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Tool dekodiert das Token lediglich — es verifiziert die Signatur NICHT. Vertrauen Sie einem dekodierten Token niemals als Nachweis einer Authentifizierung.`)
};

const nl_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit hulpmiddel decodeerdt het token alleen — het verifiëert de handtekening NIET. Vertrouw nooit op een gedecodeerd token als bewijs van authenticatie.`)
};

const fr_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet outil décode uniquement le jeton — il NE vérifie PAS la signature. Ne faites jamais confiance à un jeton décodé comme preuve d'authentification.`)
};

const it_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo strumento decodifica solo il token - NON verifica la firma. Non fidarti mai di un token decodificato come prova di autenticazione.`)
};

const pt_br2_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta apenas decodifica o token — ela NÃO verifica a assinatura. Nunca confie em um token decodificado como prova de autenticação.`)
};

const pt_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta apenas descodifica o token — NÃO verifica a assinatura. Nunca confie num token descodificado como prova de autenticação.`)
};

const ja_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このツールはトークンをデコードするだけです — シグネチャを検証しません。デコード済みトークンを認証の証拠として信用しないでください。`)
};

const zh_jw_noverify_notice = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此工具仅解码令牌——不会验证签名。切勿将解码后的令牌视为身份验证的证明。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_noverify_notice = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_noverify_notice(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_noverify_notice", locale)
	if (locale === "en") return en_jw_noverify_notice(inputs)
	if (locale === "es") return es_jw_noverify_notice(inputs)
	if (locale === "de") return de_jw_noverify_notice(inputs)
	if (locale === "nl") return nl_jw_noverify_notice(inputs)
	if (locale === "fr") return fr_jw_noverify_notice(inputs)
	if (locale === "it") return it_jw_noverify_notice(inputs)
	if (locale === "pt-BR") return pt_br2_jw_noverify_notice(inputs)
	if (locale === "pt") return pt_jw_noverify_notice(inputs)
	if (locale === "ja") return ja_jw_noverify_notice(inputs)
	return zh_jw_noverify_notice(inputs)
};